document.addEventListener("DOMContentLoaded", function() {
  setTimeout(function() {
    var writeReviewBtn = document.querySelector(".R-Button");
    if (writeReviewBtn && writeReviewBtn.textContent.trim() === "Write Review") {
      writeReviewBtn.textContent = "Write a Review";
    }
  }, 2000); // adjust timing if needed
});
